<template>
  <div>
    <p class="mb-10 h2 font-weight-bolder">{{ leave.leave.name }}</p>
    <div class="d-flex justify-content-between">
      <span> From </span>
      <p>{{ formatDate(leave.from_date) }}</p>
    </div>
    <div class="d-flex justify-content-between">
      <span> To </span>
      <p>{{ formatDate(leave.to_date) }}</p>
    </div>
    <div class="d-flex justify-content-between">
      <span> Remark </span>
      <p>{{ leave.remark }}</p>
    </div>
    <div class="d-flex justify-content-between">
      <span> Unit </span>
      <p>{{ leave.unit }}</p>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "EmployeeDailyLeave",
  props: {
    leave: {
      type: Object,
      required: true,
    },
  },
  methods: {
    /**
     * Format Date.
     *
     * @param date
     * @returns {string}
     */
    formatDate(date) {
      return dayjs(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style scoped></style>
